<div class="text-center py-3" *ngIf="billing_summary_loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!billing_summary_loading && billing_summary">
  <!-- This Matter Section -->
  <div class="billing-section">
    <h6 class="section-header" *ngIf="billing_summary.family_size > 1">This Matter</h6>

    <table class="table table-sm table-borderless billing-table">
      <tbody>
        <!-- Uninvoiced Billings (only show if non-zero) -->
        <tr *ngIf="billing_summary.net_billings?.value">
          <td class="label-col">Uninvoiced Billings</td>
          <td class="value-col" [style.color]="billing_summary.net_billings.number_color">
            {{ billing_summary.net_billings.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- All Bills -->
        <tr>
          <td class="label-col">All Bills</td>
          <td class="value-col" [style.color]="billing_summary.net_charges?.number_color">
            {{ billing_summary.net_charges?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- Total Charges -->
        <tr class="subtotal-row">
          <td class="label-col">Total Charges</td>
          <td class="value-col" [style.color]="billing_summary.net_total_charges?.number_color">
            {{ billing_summary.net_total_charges?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- Total Payments -->
        <tr>
          <td class="label-col">Total Payments</td>
          <td class="value-col" [style.color]="billing_summary.net_payments?.number_color">
            {{ billing_summary.net_payments?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- Balance Due -->
        <tr class="total-row">
          <td class="label-col"><strong>Balance Due</strong></td>
          <td class="value-col" [style.color]="billing_summary.net_balance_due?.number_color">
            <strong>{{ billing_summary.net_balance_due?.value | currency: 'USD':'symbol':'1.2-2' }}</strong>
          </td>
        </tr>

        <!-- Escrow Section (only show if there's escrow) -->
        <ng-container *ngIf="billing_summary.net_escrow?.value">
          <tr class="escrow-header-row">
            <td colspan="2" class="escrow-header">Escrow on Deposit</td>
          </tr>
          <tr class="escrow-total-row">
            <td class="label-col indent"><strong>Total Escrow</strong></td>
            <td class="value-col" [style.color]="billing_summary.net_escrow?.number_color">
              <strong>{{ billing_summary.net_escrow?.value | currency: 'USD':'symbol':'1.2-2' }}</strong>
            </td>
          </tr>
          <!-- Fee breakdown -->
          <tr *ngIf="billing_summary.net_escrow_fee?.value" class="escrow-detail-row">
            <td class="label-col indent-more">Fee</td>
            <td class="value-col small" [style.color]="billing_summary.net_escrow_fee?.number_color">
              {{ billing_summary.net_escrow_fee?.value | currency: 'USD':'symbol':'1.2-2' }}
            </td>
          </tr>
          <!-- Expense/Cost breakdown -->
          <tr *ngIf="billing_summary.net_escrow_expense?.value" class="escrow-detail-row">
            <td class="label-col indent-more">Expense</td>
            <td class="value-col small" [style.color]="billing_summary.net_escrow_expense?.number_color">
              {{ billing_summary.net_escrow_expense?.value | currency: 'USD':'symbol':'1.2-2' }}
            </td>
          </tr>
          <!-- Other breakdown -->
          <tr *ngIf="billing_summary.net_escrow_other?.value" class="escrow-detail-row">
            <td class="label-col indent-more">Other</td>
            <td class="value-col small" [style.color]="billing_summary.net_escrow_other?.number_color">
              {{ billing_summary.net_escrow_other?.value | currency: 'USD':'symbol':'1.2-2' }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Family Section (only show if family_size > 1) -->
  <div class="billing-section" *ngIf="billing_summary.family_size > 1">
    <hr class="section-divider" />
    <h6 class="section-header">Matter Family <small class="text-muted">({{ billing_summary.family_size }} matters)</small></h6>

    <table class="table table-sm table-borderless billing-table">
      <tbody>
        <!-- Uninvoiced Billings (only show if non-zero) -->
        <tr *ngIf="billing_summary.family_billings?.value">
          <td class="label-col">Uninvoiced Billings</td>
          <td class="value-col" [style.color]="billing_summary.family_billings?.number_color">
            {{ billing_summary.family_billings?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- All Bills -->
        <tr>
          <td class="label-col">All Bills</td>
          <td class="value-col" [style.color]="billing_summary.family_charges?.number_color">
            {{ billing_summary.family_charges?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- Total Charges -->
        <tr class="subtotal-row">
          <td class="label-col">Total Charges</td>
          <td class="value-col" [style.color]="billing_summary.family_total_charges?.number_color">
            {{ billing_summary.family_total_charges?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- Total Payments -->
        <tr>
          <td class="label-col">Total Payments</td>
          <td class="value-col" [style.color]="billing_summary.family_payments?.number_color">
            {{ billing_summary.family_payments?.value | currency: 'USD':'symbol':'1.2-2' }}
          </td>
        </tr>

        <!-- Balance Due -->
        <tr class="total-row">
          <td class="label-col"><strong>Balance Due</strong></td>
          <td class="value-col" [style.color]="billing_summary.family_balance_due?.number_color">
            <strong>{{ billing_summary.family_balance_due?.value | currency: 'USD':'symbol':'1.2-2' }}</strong>
          </td>
        </tr>

        <!-- Escrow Section (only show if there's escrow) -->
        <ng-container *ngIf="billing_summary.family_escrow?.value">
          <tr class="escrow-header-row">
            <td colspan="2" class="escrow-header">Escrow on Deposit</td>
          </tr>
          <tr class="escrow-total-row">
            <td class="label-col indent"><strong>Total Escrow</strong></td>
            <td class="value-col" [style.color]="billing_summary.family_escrow?.number_color">
              <strong>{{ billing_summary.family_escrow?.value | currency: 'USD':'symbol':'1.2-2' }}</strong>
            </td>
          </tr>
          <!-- Fee breakdown -->
          <tr *ngIf="billing_summary.family_escrow_fee?.value" class="escrow-detail-row">
            <td class="label-col indent-more">Fee</td>
            <td class="value-col small" [style.color]="billing_summary.family_escrow_fee?.number_color">
              {{ billing_summary.family_escrow_fee?.value | currency: 'USD':'symbol':'1.2-2' }}
            </td>
          </tr>
          <!-- Expense/Cost breakdown -->
          <tr *ngIf="billing_summary.family_escrow_expense?.value" class="escrow-detail-row">
            <td class="label-col indent-more">Expense</td>
            <td class="value-col small" [style.color]="billing_summary.family_escrow_expense?.number_color">
              {{ billing_summary.family_escrow_expense?.value | currency: 'USD':'symbol':'1.2-2' }}
            </td>
          </tr>
          <!-- Other breakdown -->
          <tr *ngIf="billing_summary.family_escrow_other?.value" class="escrow-detail-row">
            <td class="label-col indent-more">Other</td>
            <td class="value-col small" [style.color]="billing_summary.family_escrow_other?.number_color">
              {{ billing_summary.family_escrow_other?.value | currency: 'USD':'symbol':'1.2-2' }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
